import { Link } from "react-router-dom";
import { Mail, Clock, MapPin, Phone } from "lucide-react";
import { BUSINESS } from "../lib/business";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-white/[0.06] bg-ink">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-16 md:grid-cols-12 md:px-10">
      <div className="md:col-span-5">
        <Logo />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
          Laptop and desktop repair from Wilko Tech LTD. Request online, hand it over, and follow every step with your reference number.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Contact</p>
        <a href="mailto:WilkoTechLTD@outlook.com" data-testid="footer-email-link" className="mt-4 flex items-center gap-2 text-sm text-bone hover:text-ember">
          <Mail className="h-4 w-4" /> WilkoTechLTD@outlook.com
        </a>
        <p className="mt-3 flex items-center gap-2 text-sm text-bone">
          <Clock className="h-4 w-4" /> {BUSINESS.days} · {BUSINESS.hours}
        </p>
        <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="mt-3 flex items-center gap-2 text-sm text-bone hover:text-ember">
          <Phone className="h-4 w-4" /> {BUSINESS.phone}
        </a>
        <p data-testid="footer-address" className="mt-3 flex items-start gap-2 text-sm text-bone">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {BUSINESS.address}
        </p>
      </div>
      <div className="md:col-span-4">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Repairs</p>
        <div className="mt-4 flex flex-col gap-2 text-sm">
          <Link to="/request" data-testid="footer-request-link" className="hover:text-ember">Request a repair</Link>
          <Link to="/gaming-pc" data-testid="footer-gaming-link" className="hover:text-ember">Custom gaming PCs</Link>
          <Link to="/track" data-testid="footer-track-link" className="hover:text-ember">Track a repair</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="text-slate-400 hover:text-ember">Staff login</Link>
        </div>
      </div>
    </div>
    <div className="mx-auto flex max-w-[1440px] flex-col justify-between gap-2 border-t border-white/[0.06] px-5 py-6 font-mono text-xs text-slate-400 md:flex-row md:px-10">
      <span>© {new Date().getFullYear()} Wilko Tech LTD</span>
      <span>Laptop & desktop repair</span>
    </div>
  </footer>
);
